import axios from '@/utils/axios'
// 列表
export function listUser(query) {
    return axios({
        url: '/userSigningStatus/getSubscribers',
        method: 'get',
        params: query
    })
}